import type { NextRouter } from "next/router"
import { useRouter } from "next/router"

import { useToast } from "@chakra-ui/react"

import cookie from "cookie"
import type { ApolloClient } from "@apollo/client"
import { useApolloClient } from "@apollo/client"
import { type QueryClient, useQueryClient } from "@tanstack/react-query"

import { SESSION_TOKEN } from "../config"

export const useLogout = () => {
  const apolloClient = useApolloClient()
  const queryClient = useQueryClient()
  const router = useRouter()
  const toast = useToast()

  return () =>
    handleLogout({
      router,
      apolloClient,
      queryClient,
      onSuccess: () => {
        toast({ status: "success", description: "Successfully logged out!" })
      },
    })
}

export const handleLogout = async ({
  router,
  apolloClient,
  queryClient,
  onSuccess,
}: {
  router: NextRouter
  apolloClient: ApolloClient<object>
  queryClient: QueryClient
  onSuccess?: () => void
}) => {
  if (!cookie.parse(document.cookie)[SESSION_TOKEN]) return

  document.cookie = cookie.serialize(SESSION_TOKEN, "DONE", {
    maxAge: 0,
    path: "/",
  })
  await router.replace("/")
  await apolloClient.resetStore()
  queryClient.clear()

  if (onSuccess) {
    onSuccess()
  }
}
